import api from '../api'

export const getAppSettings = async () => {
  const res = await api.get('admin/staff/app-settings/')
  return res.data
}

export const updateAppSettings = async (data: { minimum_app_version: string }) => {
  const res = await api.put('admin/staff/app-settings/', data)
  return res.data
}

// App Settings Images API
export type ImageFieldName = 'connect_friends' | 'proshop_home' | 'become_coach' | 'find_game' | 'proshop_page'

export const getAppImages = async () => {
  const res = await api.get('admin/staff/app-settings/images/')
  return res.data
}

export const uploadAppImage = async (data: { field_name: ImageFieldName; image: File }) => {
  const formData = new FormData()
  formData.append('field_name', data.field_name)
  formData.append('image', data.image)
  
  const res = await api.post('admin/staff/app-settings/images/', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
  return res.data
}

export const deleteAppImage = async (data: { field_name: ImageFieldName }) => {
  const res = await api.delete('admin/staff/app-settings/images/', {
    data: { field_name: data.field_name },
  })
  return res.data
}

